export default "__VITE_ASSET__E1BJSwRY__"